import React from "react";

const IDVerificationPending = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "80vh" }}>
      <div
        style={{
          width: "100%",
          maxWidth: "550px",
          padding: "2rem 2.5rem",
          borderRadius: "5px",
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
          backgroundColor: "#fff",
          textAlign: "center",
          fontFamily: "inherit",
        }}
      >
        <div
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            border: "4px solid #f8bb86",
            margin: "0 auto 1.25rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#f8bb86" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>

        <h2 style={{ fontSize: "1.35rem", fontWeight: 600, marginBottom: "0.75rem", color: "#595959" }}>
          Verification Pending
        </h2>
        <p style={{ fontSize: "0.95rem", color: "#545454", lineHeight: 1.6 }}>
          Your school ID has been submitted and is currently under review. You will receive an email notification once your account has been approved. Please check back later.
        </p>
      </div>
    </div>
  );
};

export default IDVerificationPending;
